import { render } from "./ClientEditPage.vue?vue&type=template&id=97060bdc"
import script from "./ClientEditPage.vue?vue&type=script&lang=js"
export * from "./ClientEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__